<template>
    <div id="motionsmodal">
        <at-modal v-model="show" title="Motions" 
            @on-confirm="handleConfirm" @on-cancel="handleCancel" 
            :show-footer="false">
            
            <div class="left-align left">
                <span class="section">Basic Motions</span>
            </div>

            <div class="vspace"></div>
            
            <div class="is-overflow-x">
                <div v-for="motion in this.motions" v-bind:key="motion.type" class="inline left bottom is-pointer border motion-item">
                    <img width="100px" src="@/assets/logo.png"
                        @click="addMotion(motion.type)"/>
                    <div style="text-align:center">{{motion.name}}</div>
                </div>
            </div>

            <div class="vspace"></div>
            <div class="vspace-2"></div> 

            <div class="left-align left">
                <span class="section">Complex Motions</span>
            </div>

            <div class="is-overflow-x">
                <div v-for="motion in this.motions" v-bind:key="motion.type" class="inline left bottom is-pointer border motion-item">
                    <img width="100px" src="@/assets/logo.png"
                        @click="addMotion(motion.type)"/>
                    <div style="text-align:center">{{motion.name}}</div>
                </div>
            </div>

            <div class="vspace"></div>

        </at-modal>        
    </div>
</template>

<script>
import { NumberUtils } from '../../lib/bezieLib/Misc/Utils';
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';
import { BMotionType } from '../../lib/bezieLib/Animations/BMotionEnums';
import { Scale } from '../../lib/bezieLib/Animations/Scale';

export default {
    name: 'MotionsModal',
    props: ['show_modal','bezieAppObj'],
    data: function(){
        return {
            show : false,
            motions: [
                {
                    type : BMotionType.TRANS,
                    name : "Move"
                },
                {
                    type : BMotionType.SCALE,
                    name : "Scale"
                },
                {
                    type : BMotionType.ROTA,
                    name : "Rotate"
                }, 
                {
                    type : BMotionType.FADE,
                    name : "Alpha"
                }
            ]
        }
    },
    watch:{
        show_modal: function(val){
            this.show = this.show_modal;
            if(this.show){
                console.log("showing");
            }
        }
    },
    methods: {
        addMotion(type){
            console.log("adding motion of type "+type);
            UIEvents.addMotion(type);
            this.$emit('close', true);
        },
        handleConfirm () {
            
        },
        handleCancel () {
            this.$emit('close', true);
        }
    },
    mounted: function(){

    }
}
</script>

<style scoped>


.section{
  font-size: 16px;
}

.inline{
  display: inline-block;
}

.left-align{
    text-align: left;
}

.pitem{
  vertical-align: middle;
}

.vspace{
  height: 8px;
  width: 100%;
}

.vspace-2{
  height: 4px;
  width: 100%;
}

.left{
  margin-left: 10px;
}

.right{
  margin-right: 10px;
}

.bottom{
    margin-top: 10px;
}

.is-small-width{
  width: 60px;
}

.is-long-width{
  width: 120px;
}

.is-pointer{
    cursor: pointer;
}

.border{
    /* width | style */
    border: 1px solid lightgray;
    border-radius: 5px;
}

.motion-item{
    width: 130px;
    height: 130px;
}

.is-overflow-x{
    width: 100%;
    overflow-x: auto !important;
    white-space: nowrap;
}

</style>